import type { RouteRecordRaw } from 'vue-router';

export const dentalReportsRoutes: RouteRecordRaw[] = [
  {
    path: 'dental/revenue-by-doctor',
    name: 'dental-revenue-by-doctor',
    component: () => import('./pages/DoctorRevenuePage.vue'),
    meta: { title: 'Revenue by doctor', requiresAuth: true, permission: 'is-admin' },
  },
];
